import { makeVar, useReactiveVar } from "@apollo/client";

import { AutocompleteOptionType } from "../models/autocomplete";

export const selectedZoneVariable = makeVar<AutocompleteOptionType | null>(
  null
);

export const useSelectedZone = () => useReactiveVar(selectedZoneVariable);
